import { merge } from '@inpart-io/devtools';
import { i18nGlobalService, iufMessages } from '@inpart-io/devtools-vue';
import { createI18n } from 'vue-i18n';

import messages from './messages.json';

// Set labels and texts localized values
const i18n = createI18n({
    fallbackWarn: false,
    globalInjection: true,
    missingWarn: false,
    legacy: false,
    locale: 'en',
    messages: merge(iufMessages, messages),
    silentTranslationWarn: true
});

i18nGlobalService.init(i18n);

export { i18n };
